export function isValidVariationName(variationName: string): variationName is 'A' | 'B' {
  return variationName === 'A' || variationName === 'B'
}
